<template>
  <div class="dashboard">
    <div class="row">
      <div class="flex xs12 lg12">
        <problems />
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 lg12">
        <rules />
      </div>
    </div>
  </div>
</template>

<script>
import Problems from './Problems'
import Rules from './Rules'
export default {
  name: 'alerts',
  components: {
    Problems,
    Rules,
  },
  data() {
    return {
    }
  },
  methods: {
    launchEpicmaxToast() {
      this.showToast(`Let's work together!`, {
        icon: 'fa-star-o',
        position: 'top-right',
        duration: Infinity,
        action: {
          text: 'Hire us',
          href: 'http://epicmax.co/#/contact',
          class: 'vuestic-toasted-link',
        },
      })
    },

  },
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
